import { render, staticRenderFns } from "./MissionXIcon.vue?vue&type=template&id=471f0f12"
import script from "./MissionXIcon.vue?vue&type=script&lang=ts"
export * from "./MissionXIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports